module.exports = __webpack_public_path__ + "static/img/ma.e19de0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ma.png
// module id = I9P0
// module chunks = 1